import React from 'react'
import { useCssHandles } from '../../../shared/hooks/useCssHandles'

const CSS_HANDLES = [
  'checkoutSteps',
  'stepIndicator',
  'stepItem',
  'stepNumber',
  'stepTitle',
  'stepActive',
  'stepCompleted'
] as const

interface Step {
  number: number
  title: string
  active: boolean
  completed: boolean
}

interface CheckoutStepsProps {
  steps: Step[]
}

const CheckoutSteps: React.FC<CheckoutStepsProps> = ({ steps }) => {
  const handles = useCssHandles(CSS_HANDLES)

  return (
    <div className={`${handles.checkoutSteps} mb-8`}>
      <div className={`${handles.stepIndicator} flex justify-center`}>
        {steps.map((step, index) => (
          <div key={step.number} className="flex items-center">
            <div className={`${handles.stepItem} flex flex-col items-center`}>
              <div className={`${handles.stepNumber} w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold ${step.active ? 'bg-blue-600 text-white' :
                step.completed ? 'bg-green-600 text-white' :
                  'bg-gray-300 text-gray-600'
                }`}>
                {step.completed ? '✓' : step.number}
              </div>
              <span className={`${handles.stepTitle} mt-2 text-sm font-medium ${step.active ? 'text-blue-600' : 'text-gray-600'
                }`}>
                {step.title}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div className="w-16 h-0.5 bg-gray-300 mx-4"></div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default CheckoutSteps

